import { CrosswordPuzzle } from "./types";

/**
 * Crossword puzzles with advanced vocabulary for a well-read 10-year-old.
 * Words include literary terms, science vocabulary, and SAT-prep level words.
 */

export const PUZZLES: CrosswordPuzzle[] = [
  {
    id: "literary-terms-1",
    title: "Literary Adventures",
    difficulty: "easy",
    size: 9,
    clues: [
      {
        number: 1,
        direction: "across",
        clue: "The main character in a story",
        answer: "PROTAGONIST",
        row: 0,
        col: 0,
      },
      {
        number: 2,
        direction: "across",
        clue: "A hint about what will happen later in the story",
        answer: "FORESHADOWING",
        row: 2,
        col: 0,
      },
      {
        number: 3,
        direction: "across",
        clue: "A story with a hidden meaning or moral lesson",
        answer: "ALLEGORY",
        row: 4,
        col: 1,
      },
      {
        number: 4,
        direction: "across",
        clue: "A character who opposes the hero",
        answer: "ANTAGONIST",
        row: 6,
        col: 0,
      },
      {
        number: 5,
        direction: "down",
        clue: "The feeling or atmosphere of a story",
        answer: "MOOD",
        row: 0,
        col: 4,
      },
      {
        number: 6,
        direction: "down",
        clue: "The turning point in a story",
        answer: "CLIMAX",
        row: 2,
        col: 6,
      },
      {
        number: 7,
        direction: "down",
        clue: "The central idea or message",
        answer: "THEME",
        row: 0,
        col: 8,
      },
    ],
  },
  {
    id: "science-words-1",
    title: "Scientific Discovery",
    difficulty: "medium",
    size: 11,
    clues: [
      {
        number: 1,
        direction: "across",
        clue: "A complete change in form, like a caterpillar becoming a butterfly",
        answer: "METAMORPHOSIS",
        row: 0,
        col: 0,
      },
      {
        number: 2,
        direction: "across",
        clue: "A community of living things and their environment",
        answer: "ECOSYSTEM",
        row: 3,
        col: 2,
      },
      {
        number: 3,
        direction: "across",
        clue: "An educated guess you can test with an experiment",
        answer: "HYPOTHESIS",
        row: 5,
        col: 1,
      },
      {
        number: 4,
        direction: "across",
        clue: "Animals without backbones, like insects and spiders",
        answer: "INVERTEBRATES",
        row: 7,
        col: 0,
      },
      {
        number: 5,
        direction: "down",
        clue: "How plants make food using sunlight",
        answer: "PHOTOSYNTHESIS",
        row: 0,
        col: 4,
      },
      {
        number: 6,
        direction: "down",
        clue: "Creatures from long ago preserved in rock",
        answer: "FOSSILS",
        row: 0,
        col: 10,
      },
      {
        number: 7,
        direction: "down",
        clue: "The layer of gases surrounding Earth",
        answer: "ATMOSPHERE",
        row: 3,
        col: 7,
      },
    ],
  },
  {
    id: "vocabulary-challenge-1",
    title: "Word Master Challenge",
    difficulty: "hard",
    size: 13,
    clues: [
      {
        number: 1,
        direction: "across",
        clue: "Found everywhere; very common",
        answer: "UBIQUITOUS",
        row: 0,
        col: 1,
      },
      {
        number: 2,
        direction: "across",
        clue: "A pleasant surprise; lucky accident",
        answer: "SERENDIPITY",
        row: 2,
        col: 0,
      },
      {
        number: 3,
        direction: "across",
        clue: "Lasting only a short time; fleeting",
        answer: "EPHEMERAL",
        row: 4,
        col: 3,
      },
      {
        number: 4,
        direction: "across",
        clue: "Very eager or passionate about something",
        answer: "ENTHUSIASTIC",
        row: 6,
        col: 1,
      },
      {
        number: 5,
        direction: "across",
        clue: "A person's reason for being; Japanese concept",
        answer: "IKIGAI",
        row: 8,
        col: 5,
      },
      {
        number: 6,
        direction: "across",
        clue: "Showing great attention to detail; very careful",
        answer: "METICULOUS",
        row: 10,
        col: 2,
      },
      {
        number: 7,
        direction: "down",
        clue: "The ability to understand and share others' feelings",
        answer: "EMPATHY",
        row: 0,
        col: 3,
      },
      {
        number: 8,
        direction: "down",
        clue: "To make something seem larger or more important",
        answer: "EXAGGERATE",
        row: 2,
        col: 7,
      },
      {
        number: 9,
        direction: "down",
        clue: "Unable to be explained or understood",
        answer: "INEXPLICABLE",
        row: 0,
        col: 11,
      },
    ],
  },
  {
    id: "mixed-vocab-1",
    title: "Reading Rainbow",
    difficulty: "easy",
    size: 10,
    clues: [
      {
        number: 1,
        direction: "across",
        clue: "A brave journey or exciting experience",
        answer: "ADVENTURE",
        row: 0,
        col: 2,
      },
      {
        number: 2,
        direction: "across",
        clue: "An item with magical powers in fantasy stories",
        answer: "ARTIFACT",
        row: 2,
        col: 1,
      },
      {
        number: 3,
        direction: "across",
        clue: "A prediction about the future",
        answer: "PROPHECY",
        row: 4,
        col: 2,
      },
      {
        number: 4,
        direction: "across",
        clue: "A long difficult journey",
        answer: "ODYSSEY",
        row: 6,
        col: 3,
      },
      {
        number: 5,
        direction: "across",
        clue: "Someone with special powers, like Harry Potter",
        answer: "WIZARD",
        row: 8,
        col: 1,
      },
      {
        number: 6,
        direction: "down",
        clue: "A creature from myths and legends",
        answer: "MYTHICAL",
        row: 0,
        col: 4,
      },
      {
        number: 7,
        direction: "down",
        clue: "A hero's long search for something",
        answer: "QUEST",
        row: 2,
        col: 7,
      },
      {
        number: 8,
        direction: "down",
        clue: "The surroundings where something takes place",
        answer: "SETTING",
        row: 4,
        col: 9,
      },
    ],
  },
];
